import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconDownComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-down${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path d="M5.39998 6.16668C5.19998 6.43335 4.79998 6.43335 4.59998 6.16668L2.59998 3.50001C2.35277 3.17039 2.58796 2.70001 2.99998 2.70001L6.99998 2.70001C7.41201 2.70001 7.6472 3.17039 7.39998 3.50001L5.39998 6.16668Z" fill={useCurrentColor ? 'currentColor' : '#F52222'}/></svg>;
}

const IconDown = React.forwardRef(IconDownComponent);
export default IconDown;
